import { useParams } from "react-router-dom";
import { Hourglass } from "lucide-react";
import { NAV } from "./AdminLayout";

const PLANS = {
  kalendar: "Planiranje i zakazivanje objava po danima i satima.",
  "ai-newsroom": "AI-asistirani nacrti iz provjerenih izvora – uvijek uz obavezan ljudski pregled; AI sadržaj se nikad ne označava automatski kao provjeren.",
  "fact-checking": "Zaseban radni prostor za provjeru činjenica. Do tada: status „Provjera činjenica\" u uredničkom toku i panel Balkan Info Check u editoru članka već rade.",
  analitika: "Stvarna, GDPR-usklađena analitika čitanosti bez kolačića za praćenje.",
  distribucija: "Objava na društvenim mrežama, newsletter i push obavijesti.",
  partneri: "Partnerski računi, profili i označeni partnerski sadržaji.",
  oglasavanje: "Kampanje i upravljanje rezervisanim oglasnim pozicijama.",
};

export default function ComingSoon() {
  const { module } = useParams();
  const item = NAV.find((n) => n.soon === module);
  return (
    <div className="mx-auto max-w-xl py-16 text-center" data-testid={`coming-soon-${module}`}>
      <Hourglass className="mx-auto h-8 w-8 text-pulse" />
      <h1 className="mt-4 font-display text-3xl font-semibold text-ink">{item?.label || "Modul"}</h1>
      <p className="mt-2 text-sm font-bold uppercase tracking-[0.16em] text-muted-foreground">Dolazi u kasnijoj fazi</p>
      <p className="mt-4 text-sm text-muted-foreground">{PLANS[module]}</p>
      <p className="mt-2 text-xs text-muted-foreground">Ovaj modul još nije aktivan i ne prikazuje nikakve podatke.</p>
    </div>
  );
}
